import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { NextImage } from '@/components/NextImage';

import { Modal as BaseModal } from '../Modal';

export const InnerWrapper = styled(Box)`
  background: ${({ theme }) => theme.colors.lightGrey};
  height: 100% !important;

  ${({ theme }) => css`
    @media (min-width: ${theme.breakpoints.sm}) {
      height: auto;
      padding: 0;
    }
  `}
`;

export const Container = styled(Flex)`
  flex-direction: column;
  ${({ theme }) => css`
    gap: ${theme.spacing(2)};
    padding: ${theme.spacing(4, 2, 0, 2)};
    ${theme.media.sm.up} {
      padding: ${theme.spacing(4, 15, 0, 15)};
    }
  `}
`;

export const AccordionContainer = styled(Flex)`
  flex-direction: column;
  ${({ theme }) => css`
    ${theme.media.sm.up} {
      padding: ${theme.spacing(0, 15, 4, 15)};
    }
  `}
`;

export const Image = styled(NextImage)`
  object-fit: cover;
`;

export const Modal = styled(BaseModal)`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    height: 100%;
    max-height: 100%;
    padding-block: ${theme.spacing(2, 0)};
    ${theme.media.sm.up} {
      display: block;
      flex-direction: unset;
      height: fit-content;
      padding-block: ${theme.spacing(2, 4)};
    }
  `}
`;
export const ModalBody = styled(BaseModal.Body)`
  flex: 1;
`;
